///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespace
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.select2 = abcsetup.select2 || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Global Initialize
//
///////////////////////////////////////////////////////////////////////////////////////////////////
$(() => abcsetup.select2.init());


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.select2 = {
    init() {
        // Apply select2 field elems
        $('select.select2:not([data-autocomplete])').each(function () {
            if (!$(this).data('select2')) {
                $(this).select2({
                    //theme: "bootstrap4",
                    width: $(this).data('width') ? $(this).data('width') : $(this).hasClass('w-100') ? '100%' : 'style',
                    placeholder: $(this).data('placeholder'),
                    allowClear: Boolean($(this).data('allow-clear')),
                    minimumResultsForSearch: $(this).data('search-field'),
                    matcher: abcsetup.fieldLib._select2Matcher,
                    selectOnClose: Boolean($(this).data('allow-select-on-close')), // this allows selection of typed information on various events (ie tab, enter, blur)
                    dropdownParent: (typeof $(this).data('drop-down-parent') !== 'undefined') ? $('#'+$(this).data('drop-down-parent')) : $('body'), // see https://select2.org/troubleshooting/common-problems
                });
            }
        });

        // Apply select2 autocomplete field elems
        $('select.select2[data-autocomplete]').each(function () {
            if (!$(this).data('select2')) {
                $(this).select2({
                    //theme: "bootstrap4",
                    width: $(this).data('width') ? $(this).data('width') : $(this).hasClass('w-100') ? '100%' : 'style',
                    placeholder: $(this).data('placeholder'),
                    allowClear: Boolean($(this).data('allow-clear')),
                    selectOnClose: Boolean($(this).data('allow-select-on-close')), // this allows selection of typed information on various events (ie tab, enter, blur)
                    minimumInputLength: 1,
                    dropdownParent: (typeof $(this).data('drop-down-parent') !== 'undefined') ? $('#'+$(this).data('drop-down-parent')) : $('body'), // see https://select2.org/troubleshooting/common-problems
                    ajax: {
                        cache: true,
                        url: '/api/autocomplete/' + $(this).data('autocomplete'),
                        dataType: 'json',
                        data: function (params) {
                            var query = {
                                q: params.term,
                                //page: params.page || 1
                            }

                            return query;
                        },

                        processResults: function (data) {
                            $.each(data, function (i, d) {
                                data[i]['id'] = d.value;
                            });

                            return {
                                results: data
                            };
                        },
                    }
                });
            }
        });

        $('.select2')
            .on('select2:open', function (e) {
                if ($(e.target).parents('.modal-content').length > 0) {
                    $('.select2-container').css('z-index', 10000);
                }
            })
            .on('select2:close', function(e) {
                // Manually trigger the change event to update the Livewire model
                e.target.dispatchEvent(new Event('change'));
                $('.select2-container').css('z-index', 'auto');
            });
    },
}
